import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { MedicationRefill } from '../../models/medication-refill';

@Injectable({
  providedIn: 'root',
})
export class PatientMedicationRefillsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientMedicationRefillsEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientMedicationRefills`;

  getPatientMedicationRefills(patientId: number): Observable<MedicationRefill[]> {
    const url = `${this.patientMedicationRefillsEndpoint}?patientId=${patientId}`;
    // Opted out alongside getPatientMedications: the two are forkJoin'd in getMedications$, so leaving
    // this one on the global path meant a refills-only outage still fired setGlobalError and navigated
    // to /error — rendering MedicationsComponent's new error state behind a teardown nobody sees.
    return this.utilityService.getRequest<MedicationRefill[]>(url, { skipGlobalError: true });
  }

  createRefillRequest(
    patientMedicationId: number,
    patientId: number,
    pharmacyId: number
  ): Observable<MedicationRefill> {
    const body = { patientMedicationId, pharmacyId, comment: null };
    return this.utilityService.postRequest<MedicationRefill>(
      `${this.patientMedicationRefillsEndpoint}?patientId=${patientId}`,
      body
    );
  }
}
